module.exports = __webpack_public_path__ + "img/centerCensus3.89eaa8d4.png";